import { PartnerConfig } from '@/types'
import columbusDirectTemplate from './template'

const columbus2: PartnerConfig = {
  ...columbusDirectTemplate,
  config: {
    ...columbusDirectTemplate.config,
    codes: {
      ...columbusDirectTemplate.config.codes,
      promo: 'col2020annual',
    },
    partnerUrlSlug: 'c2cx',
  },
}

export default columbus2
